import React, { lazy, Suspense } from 'react';
import { ICON_NOTE } from '../../common/images-s3';
import { WARNING_ICON } from '../../common/images-svg';

const ImageLoader = lazy(() => import('../../common/image-loader'));

const PopupHome = ({ handleOkay, handleClose }) => {
    return (
        <>
            <div className="popup">
                <div className="c-swtich-business-individual cancel-payment">
                    <div className="body">
                            <>{WARNING_ICON}</>

                        <p className='info'>
                        Do you to want to cancel this transaction
                        </p>
                        <button type='button' className='btn btn-dark btn-okay' onClick={handleOkay}>
                            Yes
                        </button>
                        <button type='button' className='btn btn-transparent btn-cancel' onClick={handleClose}>
                            No, I changed my mind
                        </button>
                    </div>
                </div>
            </div>
            <div className="popup-backdrop"></div>
        </>
    );
};

export default PopupHome;
